// src/shell/ThemeApplicator.jsx
import { useEffect } from 'react';
import { useTenant } from './TenantContext.jsx';

export const THEME_DEFAULTS = {
  'watchmen-logistics': 'heritage-light',
  'ncl':                'modern-light',
  'elyon-demo':         'platform-light',
};

export const VALID_THEMES = [
  'heritage-light', 'heritage-dark',
  'platform-light', 'platform-dark',
  'modern-light',   'modern-dark',
];

// CSS cascade uses [data-theme='heritage'][data-mode='light'] — split attributes.
// ThemeApplicator decomposes the logical 'heritage-light' token into the two attributes.
export function resolveTheme(tenantId, tenantConfig) {
  const theme = tenantConfig?.theme
    ?? THEME_DEFAULTS[tenantId]
    ?? 'platform-light';
  return VALID_THEMES.includes(theme) ? theme : 'platform-light';
}

export function ThemeApplicator() {
  const { tenantId, tenantConfig } = useTenant();

  useEffect(() => {
    const theme = resolveTheme(tenantId, tenantConfig);
    const [palette, mode] = theme.split('-');
    document.documentElement.setAttribute('data-theme', palette);
    document.documentElement.setAttribute('data-mode', mode);
    document.documentElement.setAttribute('data-tenant', tenantId ?? 'elyon-demo');
  }, [tenantId, tenantConfig]);

  return null; // pure side-effect component
}
